import _ from 'lodash';
import { saveClientState } from './session-api';
import { getSessionInfo } from './session-store';
const SAVE_CLIENT_STATE_DEBOUNCE_DELAY = 100;
const PREFERENCES_KEY = 'preferences';
const TIPS_KEY = 'tips';
export const getClientState = () => {
    const sessionInfo = getSessionInfo();
    if (!sessionInfo || !sessionInfo.clientState) {
        return null;
    }
    return sessionInfo.clientState;
};
export const setClientState = (clientState) => {
    const sessionInfo = getSessionInfo();
    if (!sessionInfo) {
        return false;
    }
    sessionInfo.clientState = clientState;
    return true;
};
const deBouncedSaveClientState = _.debounce(saveClientState, SAVE_CLIENT_STATE_DEBOUNCE_DELAY);
function setClientStateProperty(property, key, value, saveInBackEnd = true) {
    const clientState = getClientState() || {};
    const prop = clientState[property] || {};
    if (_.isEqual(prop[key], value)) {
        return null;
    }
    prop[key] = value;
    clientState[property] = prop;
    setClientState(clientState);
    if (saveInBackEnd) {
        return saveClientState(clientState);
    }
    return null;
}
export const getClientStateProperty = (property, key) => {
    const clientState = getClientState();
    if (!clientState) {
        return null;
    }
    const prop = clientState[property];
    if (!prop) {
        return null;
    }
    return prop[key];
};
export const getUserPreferences = () => {
    const clientState = getClientState();
    if (!clientState) {
        return {};
    }
    return clientState[PREFERENCES_KEY] || {};
};
export const setPreference = (key, value, saveInBackEnd = true) => {
    setClientStateProperty(PREFERENCES_KEY, key, value, saveInBackEnd);
};
export const getPreference = (key) => {
    return getClientStateProperty(PREFERENCES_KEY, key);
};
export const removeUserPreferences = key => {
    const clientState = getClientState() || {};
    const clientPreferences = clientState[PREFERENCES_KEY] || {};
    delete clientPreferences[key];
    setClientState(clientState);
    deBouncedSaveClientState(clientState)?.then();
};
export const setTip = (key, value) => {
    setClientStateProperty(TIPS_KEY, key, value);
};
export const getTip = (key) => {
    return getClientStateProperty(TIPS_KEY, key);
};
//# sourceMappingURL=client-state.js.map